module.exports = __webpack_public_path__ + "static/media/marker_Midblock_shared.f10339c7.svg";